<template>
  <div>
    <!--<b-row>-->
      <!--<b-col>-->
        <!--<div v-if="created" class="alert alert-success" role="status">{{ created.title }} {{$t('notifications.created')}}.</div>-->
        <!--<div v-if="updated" class="alert alert-success" role="status">{{ updated.name }} {{$t('notifications.updated')}}.</div>-->
        <!--<div v-if="isLoading || deleteLoading" class="alert alert-info" role="status">{{$t('notifications.loading')}}...</div>-->
        <!--<div v-if="error" class="alert alert-danger" role="alert">-->
          <!--<span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ error }}-->
        <!--</div>-->
        <!--<div v-if="deleteError" class="alert alert-danger" role="alert">-->
          <!--<span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ deleteError }}-->
        <!--</div>-->
      <!--</b-col>-->
    <!--</b-row>-->
    <b-row>
      <b-col v-if="isLoading">
        <Loader size="md"></Loader>
      </b-col>
      <b-col v-else>
        <EXCMAgreementConsentForm
                v-if="item"
                :handle-submit="onSendForm"
                :handle-update-field="updateField"
                :values="item"
                :errors="violations"
                :initial-values="retrieved" />
      </b-col>
    </b-row>
    <!--<b-row>-->
      <!--<b-col>-->
        <!--<router-link-->
                <!--v-if="item"-->
                <!--:to="{ name: 'EXCMAgreementConsentList' }"-->
                <!--class="btn btn-default">Back to list</router-link>-->
        <!--<button-->
                <!--class="btn btn-danger"-->
                <!--@click="del">Delete</button>-->
      <!--</b-col>-->
    <!--</b-row>-->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXCMAgreementConsentForm from './Form.vue'
import Loader from '../../Layout/Loader'

export default {
  components: {
    EXCMAgreementConsentForm,
    Loader
  },

  data () {
    return {
      routeName: '',
      item: {}
    }
  },

  props: {
    agreementConsentId: {
      type: String,
      default: null
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'excmagreementconsent/update/isLoading',
      error: 'excmagreementconsent/update/error',
      deleteError: 'excmagreementconsent/del/error',
      deleteLoading: 'excmagreementconsent/del/isLoading',
      created: 'excmagreementconsent/create/created',
      deleted: 'excmagreementconsent/del/deleted',
      retrieved: 'excmagreementconsent/update/retrieved',
      updated: 'excmagreementconsent/update/updated',
      violations: 'excmagreementconsent/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXCMAgreementConsentList' })
    },
    updated: function (updated) {
      if (this.routeName === 'EXCMAgreementShow') {
        this.$Swal({
          title: this.$t('notifications.updated'),
          type: 'success'
        })
        this.$store.state.modals.excmagreementconsent.update.updated = 1
        this.$store.state.modals.excmagreementconsent.update.close = 1
      }
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.routeName = this.$route.name
    if (this.agreementConsentId) {
      this.retrieve(decodeURIComponent(this.agreementConsentId))
    } else {
      this.retrieve(decodeURIComponent(this.$route.params.id))
    }
  },

  methods: {
    ...mapActions({
      createReset: 'excmagreementconsent/create/reset',
      deleteItem: 'excmagreementconsent/del/del',
      delReset: 'excmagreementconsent/del/reset',
      retrieve: 'excmagreementconsent/update/retrieve',
      updateReset: 'excmagreementconsent/update/reset',
      update: 'excmagreementconsent/update/update',
      updateRetrieved: 'excmagreementconsent/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this excmagreementconsent ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
